import { useCallback, useRef } from 'react'

// jarallax needs `window`: load it in the browser only, so the content
// (hero headings, search form) can still be server-rendered
const loadJarallax = () => import('jarallax').then((mod) => mod.jarallax)

const BgParallax = ({
  type,
  speed,
  imgSrc,
  imgSrcSet,
  priority,
  overlay,
  children,
  contentWrapper,
  className,
  ...props
}) => {

  // Create ref callback
  const useHookWithRefCallback = () => {
    const el = useRef(null)
    const setParallax = useCallback(node => {

      // Destroy Jarallax on component unmount
      if (el.current) {
        const previous = el.current
        loadJarallax().then((jarallax) => jarallax(previous, 'destroy'))
      }

      // Init Jarallax on component mount and update
      if (node) {
        loadJarallax().then((jarallax) => jarallax(node, {
          type: type || 'scroll',
          speed: speed || 0.3
        }))
      }
      
      el.current = node
    }, [])
    
    return [setParallax]
  }
  
  const [el] = useHookWithRefCallback()

  // Overlay element
  let overlayEl
  if (overlay === 'gradient') {
    overlayEl = <span className='img-overlay bg-transparent opacity-100' style={{backgroundImage: 'linear-gradient(0deg, rgba(31, 27, 45, .7), rgba(31, 27, 45, .7)'}}></span>
  } else {
    overlayEl = <span className='img-overlay' style={{opacity: overlay + '%'}}></span>
  }  

  // Render markup
  return (
    <div ref={el} {...props} className={`jarallax${className ? ` ${className}` : ''}`}>
      {overlay && overlayEl}
      {/* A real <img> (not a CSS background) so the browser finds it in the HTML;
          `priority` marks it as the page's LCP image */}
      <img
        className='jarallax-img'
        src={imgSrc}
        srcSet={imgSrcSet}
        sizes={imgSrcSet ? '100vw' : undefined}
        alt=''
        fetchPriority={priority ? 'high' : undefined}
        loading={priority ? 'eager' : 'lazy'}
        decoding='async'
      />
      {contentWrapper ? <div {...contentWrapper} className={`content-overlay${contentWrapper.className ? ` ${contentWrapper.className}` : ''}`}>
        {children}
      </div> : <div className='content-overlay'>
        {children}
      </div>}
      
    </div>
  )
}

export default BgParallax
